import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation CycleDeleteMutation (
  $workspace: ID!,
  $id: ID!
) {
  cycleDelete (
    workspace: $workspace
    id: $id
  )
}`

async function requestCycleDelete (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('cycle-delete', errors)
  }
  return data.cycleDelete
}

export default requestCycleDelete
